import { create } from 'zustand'

// Lightweight UI state: desktop sidebar collapse + mobile drawer open.
interface UiState {
  sidebarCollapsed: boolean
  drawerOpen: boolean
  toggleSidebar: () => void
  setDrawerOpen: (open: boolean) => void
}

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: false,
  drawerOpen: false,
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setDrawerOpen: (open) => set({ drawerOpen: open }),
}))
